import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        width: 'fit-content',
        marginLeft: '1rem',
        padding: '0',
        backgroundColor: theme?.app?.applicationColors.enumColors.white || '#FFFFFF',
        fontSize: '.8rem',
        textTransform: 'none' as 'none',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'}`,
        borderRadius: '20px'
    },
    icon: {
        width: '32px',
        height: '24px',
        padding: 0
    },
    searchIcon: {
        height: '12px',
        width: '12px'
    },
    active: { backgroundColor: theme?.app?.clientTheme.colors.highlightColor3 || '#B9D9EC' },
    searchInput: {
        border: 'none',
        borderRight: '1px solid #ddd'
    },
    cancel: {
        height: '12px',
        width: '12px',
        alignSelf: 'center' as 'center'
    },
    searchBarOpen: {
        width: '12rem',
        marginLeft: '.5rem',
        display: 'inline-block' as 'inline-block'
    },
    searchBarClosed: { display: 'none' as 'none' },
    buttonClosed: { '&:hover': { backgroundColor: theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf' }},
    tooltip: { top: '-10px !important' }
}));